import SignUp from "./SignUp";
import TPKSignUp from "./TPKSignUp";

export {
	TPKSignUp
}
export default SignUp;